<template>
	<PublishForm formType="truck" />
</template>

<script>
import PublishForm from "@/components/forms/PublishForm.vue";
export default {
	components: { PublishForm },
};
</script>

<style scoped></style>
